import api from "./api.js";

export default class CouponApi {
  static async create(data) {
    return await api.post(`coupon`, data);
  }
  static async getList(data) {
    return await api.get(`coupon`, data);
  }
  static async getById(id, data) {
    return await api.get(`coupon/${id}`, data);
  }
  static async delete(data) {
    return await api.del(`coupon`, data);
  }
}
